import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Observable } from '@app/shared/rx';
import { EPlacement, IFieldPreferences, ILabelGroup } from '@app/shared/types';
import { asObservable } from '@app/shared/utils';
import { get, map } from 'lodash';

@Component({
  selector: 'xvi-xux-multi-selection-list',
  templateUrl: './xux-multi-selection-list.component.html',
  styleUrls: ['./xux-multi-selection-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxMultiSelectionListComponent implements OnInit {
  @Input() public field: IFieldPreferences;

  public dataObs: Observable<ILabelGroup[]>;
  public placement: EPlacement = EPlacement.auto;
  public showTooltip: boolean = true;

  public ngOnInit(): void {
    this.placement = get(this.field, 'widgetData.placement', EPlacement.auto);
    this.showTooltip = get(this.field, 'widgetData.showTooltip', true);
    this.dataObs = asObservable(this.field.control.value);
  }

  public getTooltip(row: ILabelGroup): string {
    return map(row.items, 'item').join(' ');
  }
}
